import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {
    type OttopilotEventContainerTemplateConfiguration,
    ottopilotEventContainerTemplateConfigurationValidator,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventContainersWorkspaceCapability/domain/OttopilotEventContainerTemplateConfiguration";
import {z as zod} from "zod";

export type OttopilotEventContainersWorkspaceCapabilityConfiguration = {
    /** Business configuration keyed by Event Container template ID, not object ID. Capability revisions and audit snapshots version this map. */
    eventContainerTemplates: Record<Uuid, {
        configuration: OttopilotEventContainerTemplateConfiguration;
    }>;
};

export const ottopilotEventContainersWorkspaceCapabilityConfigurationValidator: zod.ZodType<OttopilotEventContainersWorkspaceCapabilityConfiguration> =
    zod.strictObject({
        eventContainerTemplates: zod.record(uuidZodValidator, zod.strictObject({
            configuration: ottopilotEventContainerTemplateConfigurationValidator,
        })),
    });
